var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subject app-container"},[_c('tabHeader',{attrs:{"slideData":_vm.slideData,"tab":_vm.tab},on:{"headerTabBack":_vm.headerTabBack}}),_c('div',{staticClass:"subject-container"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }